// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, signInWithRedirect, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
let app;
let db;
let auth;
let functions;
const googleProvider = new GoogleAuthProvider();

try {
  app = initializeApp(firebaseConfig);
  console.log('Firebase app initialized successfully');
  
  db = getFirestore(app);
  console.log('Firestore initialized successfully');
  
  auth = getAuth(app);
  
  functions = getFunctions(app);
  console.log('Cloud Functions initialized successfully');
  
  // Set persistence to LOCAL
  setPersistence(auth, browserLocalPersistence)
    .then(() => {
      console.log('Auth persistence set to LOCAL');
    })
    .catch((error) => {
      console.error('Error setting auth persistence:', error);
    });

  // Only connect to emulators in development
  if (process.env.NODE_ENV === 'development') {
    import('firebase/firestore').then(({ connectFirestoreEmulator }) => {
      connectFirestoreEmulator(db, 'localhost', 8080);
    });
    
    import('firebase/auth').then(({ connectAuthEmulator }) => {
      connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    });
    
    import('firebase/functions').then(({ connectFunctionsEmulator }) => {
      connectFunctionsEmulator(functions, 'localhost', 5001);
    });
    
    console.log('🔧 Development mode: Connected to emulators');
  } else {
    console.log('🚀 Production mode: Using live Firebase services');
  }
} catch (error) {
  console.error('Error initializing Firebase:', error);
  throw error;
}

export { app, db, auth, functions, googleProvider, signInWithRedirect };

